import React, { useEffect } from 'react';
import { createModal } from 'react-modal-promise';
import { Modal, theme } from 'Ui';
import styled from 'styled-components';
import { isMobile } from 'react-device-detect';
import { AlmaStep } from './AlmaStep';
import { AlmaLogo } from 'Ui/Icons/icons';
import { getModalEventName } from 'Libs/GA4/common';

type ModalProps = {
  open: boolean;
  close: (shouldGoOn: boolean) => void;
  modalName?: string;
};

const AlmaModalTitle = styled.div`
  display: flex;
  gap: 16px;
  padding: 2.4rem 0;
  @media screen and (max-width: 48rem) {
    padding: 2.4rem 0 0;
  }
`;

const AlmaTitle = styled.div`
  color: ${theme.v2.black};
  font-family: var(--font-primary);
  font-size: 1.6rem;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  @media screen and (max-width: 48rem) {
    font-size: 1.2rem;
  }
`;

const AlmaModalBody = styled.div`
  gap: 24px;
  padding: 2rem 3.2rem 3.2rem;
  @media screen and (max-width: 48rem) {
    padding: 0.2rem;
  }
`;

const Terms = styled.div`
  color: ${theme.v2.grayScale[400]};
  font-family: var(--font-primary);
  font-size: 8px;
  font-style: normal;
  font-weight: 500;
  line-height: 12px;
  span {
    text-decoration: underline;
  }
  a {
    text-decoration: underline;
  }
`;

const AlmaSteps = styled.div`
  display: flex;
  /* width: 801px; */
  justify-content: space-between;
  align-items: center;
  padding: 2.4rem 0;
  @media screen and (max-width: 48rem) {
    flex-direction: column;
    gap: 16px;
    padding: 2.4rem 1.6rem 2.4rem 0;
  }
`;

const StepsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0 11.5rem;
  max-width: 100%;
  hr {
    width: 100%;
    height: 1px;
    background-color: #dedcdc;
    border: none;
  }
  @media screen and (max-width: 48rem) {
    display: flex;
    padding: 0.087px 0px 0.913px 0.5px;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    margin: auto 2.3rem;
    hr {
      border: none;
      border-left: 1px solid #dedcdc;
      height: 13.2rem;
      width: 1px;
      margin: 0 1rem;
    }
  }
`;

const StepNumber = styled.div`
  color: ${theme.light.colors.black};
  text-align: center;
  font-family: var(--font-primary);
  font-weight: 400;
  font-size: 1rem;
  font-style: normal;
  line-height: normal;
  background-color: var(--border-default, #dedcdc);
  border-radius: 100%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 19rem;
`;

const StepsMainContainer = styled.div`
  display: flex;
  flex-direction: column;
  @media screen and (max-width: 48rem) {
    flex-direction: row;
  }
`;

const StepContainer = styled.div``;

const AlmaModal = ({
  open,
  close,
  modalName = 'split_payment_infos_bakset',
}: ModalProps) => {
  useEffect(() => {
    getModalEventName(modalName);
  }, [modalName]);
  type StepProps = {
    number?: string;
  };
  const Step = ({ number }: StepProps) => (
    <StepContainer>
      <StepNumber>{number}</StepNumber>
    </StepContainer>
  );
  return (
    <Modal isOpen={open} size="large" onClose={() => close(false)}>
      <AlmaModalBody>
        <AlmaModalTitle>
          <AlmaLogo width={isMobile ? 68.5 : 130} height={isMobile ? 21 : 40} />
          <div>
            <AlmaTitle>PAIEMENT EN PLUSIEURS FOIS</AlmaTitle>
            <AlmaTitle>PAR CARTE BANCAIRE</AlmaTitle>
          </div>
        </AlmaModalTitle>
        <StepsMainContainer>
          <StepsContainer>
            <Step number="1" />
            <hr />
            <Step number="2" />
            <hr />
            <Step number="3" />
          </StepsContainer>
          <AlmaSteps>
            <AlmaStep
              title={'Choisissez ALMA'}
              secondaryParagraph={true}
              paragraph={'Lorsque vous sélectionnez votre mode de paiement.'}
            />
            <AlmaStep
              title={'RENSEIGNEZ'}
              paragraph={`Votre numéro de carte bancaire, comme lors d'un paiement classique.`}
            />
            <AlmaStep
              title={'ET VOILÀ !'}
              paragraph={'Vous avez une réponse immédiate.'}
            />
          </AlmaSteps>
        </StepsMainContainer>
        <Terms>
          Offre de financement sans assurance avec apport obligatoire, réservée
          aux particuliers et valable pour tout achat de 100 € à 2000 €. Sous
          réserve d'acceptation par ALMA. Vous disposez d'un délai de 14 jours
          pour renoncer à votre crédit. ALMA SAS - 176 avenue Charles de Gaulle
          92200 Neuilly-sur-Seine - immatriculée au RCS Nanterre sous le numéro
          839 100 575. Support client : <span>support@getalma.eu</span> - site
          web :
          <a href="https://almapay.com/fr-FR/clients">
            https://almapay.com/fr-FR/clients
          </a>
        </Terms>
      </AlmaModalBody>
    </Modal>
  );
};

export default createModal(AlmaModal);
